export const FIRST_NAME = 'firstName';
export const LAST_NAME = 'lastName';
export const DISPLAY_LANGUAGE = 'displayLanguage';
export const DATE_FORMAT = 'dateFormat';
export const NUMBER_FORMAT = 'numberFormat';
export const TIME_ZONE = 'timezone';
export const THEME = 'theme';
